import React, { useState, useEffect } from "react";
import "./style.css";

export const CourseSaleCountdown = ({remainingTime=0, language="en"}) => {

  let realRemainingTime = remainingTime;
  let localRemainingTime = remainingTime;

  const [state, setState] = useState({

    countdown_days: 0,
    countdown_hours: 0,
    countdown_minutes: 0,
    countdown_seconds: 0

  });


  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  const getRemainingTime = () => {

    if ( realRemainingTime != 0 ) {

      const nowDate = new Date();
      const d = new Date(realRemainingTime);

      const days = d.getDay() - nowDate.getDay();
      const h = d.getHours() - nowDate.getHours();
      const m = d.getMinutes() - nowDate.getMinutes();
      const s = d.getSeconds() - nowDate.getSeconds();

      return Math.floor((d.getTime()-nowDate.getTime())/1000);

    }

    const d = new Date();

    const h = d.getHours();
    const m = d.getMinutes();
    const s = d.getSeconds();

    return (24*60*60) - (h*60*60) - (m*60) - s;


    /*const now = new Date();
    const currentUTCDate = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0, 0);

    // Calculate the time difference in seconds
    const timeDifferenceInSeconds = Math.floor((now - currentUTCDate) / 1000);

    return 24*3600 - timeDifferenceInSeconds;*/

  }
  

  const updateTime = () => {

    localRemainingTime = getRemainingTime();

    if ( localRemainingTime < 0 ) {
      localRemainingTime = 0;
    }

    let lcountdown_seconds = localRemainingTime;
    let lcountdown_minutes = Math.floor(lcountdown_seconds / 60);
    let lcountdown_hours = Math.floor(lcountdown_minutes / 60);
    let lcountdown_days = Math.floor(lcountdown_hours / 24);

    lcountdown_hours = lcountdown_hours % 24;
    lcountdown_seconds = lcountdown_seconds % 60;
    lcountdown_minutes = lcountdown_minutes % 60;

    setState({
      countdown_days: lcountdown_days,
      countdown_hours: padTo2Digits(lcountdown_hours),
      countdown_minutes: padTo2Digits(lcountdown_minutes),
      countdown_seconds: padTo2Digits(lcountdown_seconds)
    });

  }


  useEffect(() => {

    realRemainingTime = remainingTime;

    //if ( remainingTime > 2 ) {
        updateTime();
      const interval = setInterval(() => {
        updateTime();
      }, 1000);
      return () => clearInterval(interval);
    //}

  }, [remainingTime]);


  let translations;

  if ( language == "es" ) {
    translations = ["días", "horas", "minutos", "segundos"];
  }
  else if ( language == "fr" ) {
    translations = ["jours", "heures", "minutes", "secondes"];
  }
  else if ( language == "pt" ) {
    translations = ["dias", "horas", "minutos", "segundos"];
  }
  else if ( language == "ru" ) {
    translations = ["дней", "часов", "минут", "секунд"];
  }
  else {
    translations = ["days", "hours", "minutes", "seconds"];
  }

  return (
    <div className="course_sale_countdown">
      <div className="countdown_square_container">
        <div className="countdown_square">{state.countdown_days}</div>
        <div className="countdown_unit">{translations[0]}</div>
      </div>

      <div className="countdown_square_container">
        <div className="countdown_square">{state.countdown_hours}</div>
        <div className="countdown_unit">{translations[1]}</div>
      </div>

      <div className="countdown_square_container">
        <div className="countdown_square">{state.countdown_minutes}</div>
        <div className="countdown_unit">{translations[2]}</div>
      </div>

      <div className="countdown_square_container">
        <div className="countdown_square">{state.countdown_seconds}</div>
        <div className="countdown_unit">{translations[3]}</div>
      </div>
    </div>
  );
};
